import { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import * as D from "assets/iconsSVG/rowTopDownIcon";
import * as MaterialUI from "@material-ui/core";
import { useTransferirLead } from "services/api/AppWeb_Oportunidade/put-transferir-lead";
import InputComponent from "components/InputG";
import * as S from "./styles";

interface Data {
  onClose: () => void;
  dataDetalheOportunidade: any;
  refetchDetalheOportunidade: () => void;
  refetchHistorico: () => void;
}

export const ModalTransferirProposta = (data: Data) => {
  const [codigoLead, setCodigoLead] = useState<string>("");

  const { mutate: mutateTransferirLead, isLoading: isLoadingTransferirLead } =
    useTransferirLead();

  const handleSubmit = () => {
    mutateTransferirLead(
      {
        idOportunidade: data.dataDetalheOportunidade.idOportunidade,
        codigoLead,
      },
      {
        onSuccess: () => {
          data.refetchDetalheOportunidade();
          data.refetchHistorico();
          data.onClose();
        },
      }
    );
  };

  return (
    <S.Content>
      <S.Header>
        <S.Row style={{ justifyContent: "space-between" }}>
          <D.RowTopDownIcon />
          <S.CloseButton onClick={data.onClose}>
            <IoCloseOutline size={32} />
          </S.CloseButton>
        </S.Row>
        <S.SpaceY space={16} />
        <S.TextTitle>Transferir Proposta</S.TextTitle>
      </S.Header>
      <S.SpaceY space={16} />
      <S.Body>
        <S.InputContainer>
          <InputComponent
            label="Código do Lead *"
            value={codigoLead}
            placeholder="Insira o código do Lead"
            onChange={(e) => {
              setCodigoLead(e.target.value);
            }}
          />
        </S.InputContainer>
        <S.SpaceY space={32} />
        <S.Row style={{ gap: 16 }}>
          <S.Button
            onClick={() => {
              data.onClose();
            }}
            color="#ffffff"
            border="1px solid #A3A3A6"
          >
            <S.TextButton color="#424248">Cancelar</S.TextButton>
          </S.Button>
          <S.Button
            onClick={() => {
              handleSubmit();
            }}
            disabled={isLoadingTransferirLead || !codigoLead}
          >
            {isLoadingTransferirLead ? (
              <MaterialUI.CircularProgress
                size={22}
                style={{ color: "#ffffff" }}
              />
            ) : (
              <S.TextButton color="#FFFFFF">Transferir</S.TextButton>
            )}
          </S.Button>
        </S.Row>
      </S.Body>
    </S.Content>
  );
};
